import { currentBrowserInfo } from "@goodgamestudios/createjs-utilities";

export class AssetUrlConvertor {
    private isPNG = /.png$/i;

    public convert(file: string): string {
        if (this.isPNG.test(file) && window.useMinAssets) {
            if (
                (currentBrowserInfo.isChrome && parseInt(currentBrowserInfo.version, 10) > 23) ||
                (currentBrowserInfo.isFireFox && parseInt(currentBrowserInfo.version, 10) >= 65)
            ) {
                file = file.replace(/.png$/, ".webp");
            }
            return file; //replace URL with modified paths
        }
        return file; //do noting
    }
}
